import React from "react";
import classes from "../../GlobalCSS/main.module.css";

const footer = () => {
    return (
        <div className={classes.Footer}>
            <p>by NP &copy; 2019</p>
        </div>
    );
};

export default footer;
